__turbopack_context__.v({
  "content": "CircularPercentage-module-scss-module__7iC56W__content",
  "mainCircle": "CircularPercentage-module-scss-module__7iC56W__mainCircle",
  "root": "CircularPercentage-module-scss-module__7iC56W__root",
});
